import { useCallback, useState } from "react";

type UseOpenCloseOptions = {
  defaultOpen?: boolean;
};

export function useOpenClose(
  options: UseOpenCloseOptions = {}
) {
  const { defaultOpen = false } = options;

  const [isOpen, setIsOpen] = useState(defaultOpen);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return {
    isOpen,
    open,
    close,
    toggle,
    setIsOpen,
  };
}